export default {"src":"/_next/static/media/cart-fill.fc0689c1.svg","height":10,"width":13};